import React from 'react';

import css from '../../../styles/modules/BoxContainer/createlogbutton.module.css';

export const createLogButton = (
  user,
  brandLogo,
  history,
  showLogin,
  branding,
  showLoginButton,
) => {
  const mobile = window.screen.width < 1200;
  return (
    <div className={css.container}>
      {!user && !showLogin ? (
        <div className={css.logoBar}>
          <img src={brandLogo} className={css.logo} alt="" hidden={mobile} />
          <img src={brandLogo} className={css.logo} alt="" hidden={!mobile} />
        </div>
      ) : null}
    </div>
  );
};
